import { required, min, max } from "../constants/formValidators";

export const RecipeKeys = {
	ID: "id",
	NAME: "name",
	SLUG: "slug",
	CALORIES: "get_range_calorie",
	CARBS: "get_range_carb",
	PROTEINS: "get_range_protein",
	IMAGES: "main_image",
	PHOTO_O: "photo_o",
	PHOTO_S: "photo_s",
	PHOTO_M: "photo_m",
	PHOTO_L: "photo_l",
	COMMENTS: "com_num",
	RATING: "com_avg",
	PHASE: "main_phase",

	SEARCH_INGREDIENT_RESULTS_LIMIT: 10,
	RECIPE_COMMENTS_APPROVAL_RESULTS_LIMIT: 10
};

export const sortItemList = [
	{
		name: "Name",
		field: "name",
		sort: "",
		sortReverse: false
	},
	{
		name: "Rating",
		field: "com_avg",
		sort: "",
		sortReverse: true
	},
	{
		name: "Calories",
		field: "range_calorie",
		sort: "",
		sortReverse: false
	}
];

export const mainStatusList = [
	{
		label: "Active",
		name: "active"
	},
	{
		label: "Featured",
		name: "featured"
	},
	{
		label: "Public",
		name: "public"
	}
];

export const franchiseRegionList = [
	{
		label: "US",
		name: "US"
	},
	{
		label: "ME",
		name: "ME"
	}
];

export const timeAndServeList = [
	{
		label: "Preptime",
		name: "preptime",
		validate: [required, min(1), max(2147483647)],
		type: "number"
	},
	{
		label: "Cooktime",
		name: "cooktime",
		validate: [required, min(1), max(2147483647)],
		type: "number"
	},
	{
		label: "Yields",
		name: "yields",
		validate: [required, min(1), max(2147483647)],
		type: "number"
	},
	{
		label: "Serving size",
		name: "serving_size",
		validate: [required],
		type: "text"
	}
];

export const servingsFieldList = [
	{
		label: "Vegetable",
		name: "vegetable",
		validate: [required, min(0), max(2147483647)],
		type: "number"
	},
	{
		label: "Fruit",
		name: "fruit",
		validate: [required, min(0), max(2147483647)],
		type: "number"
	},
	{
		label: "Dairy",
		name: "dairy",
		validate: [required, min(0), max(2147483647)],
		type: "number"
	},
	{
		label: "Fat",
		name: "fat",
		validate: [required, min(0), max(2147483647)],
		type: "number"
	},
	{
		label: "Starch",
		name: "starch",
		validate: [required, min(0), max(2147483647)],
		type: "number"
	},
	{
		label: "Misc",
		name: "misc",
		validate: [required, min(0), max(2147483647)],
		type: "number"
	},
	{
		label: "Protein Calories",
		name: "protein_calories",
		validate: [required, min(0), max(2147483647)],
		type: "number"
	}
];

export const servingsList = [
	{
		id: 1,
		name: "Fat"
	},
	{
		id: 2,
		name: "Vegetable"
	},
	{
		id: 3,
		name: "Fruit"
	},
	{
		id: 4,
		name: "Dairy"
	},
	{
		id: 5,
		name: "Starch"
	},
	{
		id: 6,
		name: "Misc"
	},
	{
		id: 7,
		name: "Zero"
	},
	{
		id: 8,
		name: "None"
	}
];

export const foodTypeList = [
	{
		id: 1,
		name: "VERY LEAN"
	},
	{
		id: 2,
		name: "LEAN"
	},
	{
		id: 3,
		name: "MEDIUM"
	},
	{
		id: 4,
		name: "PROTEIN"
	},
	{
		id: 5,
		name: "None"
	}
];

export const declineCodes = [
	{
		id: "A",
		name: "User requested"
	},
	{
		id: "C",
		name: "Not within guidelines of the Acute Stage diet"
	},
	{
		id: "B",
		name: "Duplicate recipe"
	},
	{
		id: "E",
		name: "Information incomplete; quantities and/or measures required"
	},
	{
		id: "D",
		name: "Not relatively easy to prepare with commonly available items"
	},
	{
		id: "Z",
		name: "Not appropriate for publishing"
	}
];
